
import { ref, onMounted, onUnmounted, defineEmits, watch, Ref } from "vue";
import { defineComponent } from "vue";
import useEmitter from "@/composables/Emmiter";
import Api from "../../services/Api";
import s3 from '../../services/S3Service'
import useAlert from "../../composables/Alert";
import { Modal } from "bootstrap";
import ModalLogProduto from "./components/ModalLogProduto.vue";
import { useLoaderStore } from "@/store/LoaderStore"; //Componente de Loading
import { log } from "node:console";

export default defineComponent({

  name: "LogProdutos",
  
  components: {
    ModalLogProduto,
  },

  setup() {
    const emitter = useEmitter();

    const logProdutoModal: Ref<any> = ref()
    const logSelecionado: Ref<any> = ref()

    const limite = ref(30);
    const pagina: Ref<any> = ref(null);

    const filtro: Ref<any> = ref({ loja: [], automocao: [], comErro: null });

    const loadLog: Ref<boolean> = ref(false);
    const skeleton: Ref<boolean> = ref(false);

    

    const arrayLog: Ref<any> = ref([]);



    async function buscaLogPaginado(paginaParam: number, filtrou: boolean = false) {
      try {
        const sectionLoadLog = document.getElementById('load'); //Variável da section do rodapé com o botão de Carregar Mais
        const loadLogButton = document.getElementById('loadLogButton'); //Variável da div do botão com o método buscaLogPaginado
        
        //Verifica se é a primeira página de resultados
        if(paginaParam == 1) {
          //Oculta o botão de Carregar Mais
          if(loadLogButton?.classList.contains('d-flex')) loadLogButton?.classList.remove('d-flex');
          loadLogButton?.classList.add('d-none');

          //Habilita o skeleton
          skeleton.value = true;

          //Limpa a tela de resultados
          arrayLog.value = [];
        }

        loadLog.value = true;
  
        const { data } = await Api.get("produtoIntegracaoPaginado", { pagina: paginaParam, limite: limite.value, ...filtro.value });
  
        loadLog.value = false;
        
        //Verifica se é a primeira página de resultados
        if(paginaParam == 1) {          
          //Reexibe o botão de Carregar Mais
          if(loadLog.value == false) loadLogButton?.classList.replace('d-none', 'd-flex');

          //Desabilita o skeleton
          skeleton.value = false;
        }
        
        pagina.value = paginaParam;
        
        if(filtrou) arrayLog.value = [];
        
        arrayLog.value = [ ...arrayLog.value, ...data.logs ];

        //Verifica se a quantidade de resultados encontrados é menor que o limite da página
        if(arrayLog.value.length < limite.value || data.logs.length === 0) {
          //Se for menor, oculta toda a section para evitar mais requisições a api 
          sectionLoadLog?.classList.replace('d-flex', 'd-none');
        } else {
          sectionLoadLog?.classList.replace('d-none', 'd-flex');
        } 
      } catch (error) { 
        loadLog.value = false; 
      }
    }

    emitter.on("FilterLogProdutos", (props: any) => {
      filtro.value = props
      buscaLogPaginado(1, true);
    });


    ///////////////////// MODAL PRODUTO LOG /////////////////////
    function abreModal(log?) {
      logSelecionado.value = log || {}
      logProdutoModal.value.show()
    }

    async function fechaModal() {
      logSelecionado.value = {}
      logProdutoModal.value.hide()
    }

    ///////////////////// MODAL PRODUTO LOG /////////////////////


    onMounted(() => {

      logProdutoModal.value = new Modal(document.querySelector(`#ModalLogProduto`));

      const observer = new IntersectionObserver(entries => {
        if(entries[0].isIntersecting) buscaLogPaginado(pagina.value ? pagina.value + 1 : 1);
      }).observe(document.querySelector("#load") as any);


    })




    return {

      arrayLog,
      loadLog,
      skeleton,
      buscaLogPaginado,
      pagina,
      abreModal,
      fechaModal,
      logSelecionado,
      history

    }



  }

});
